import getMessages from "../utils/getMessages";
import enMessages from "./en-US";

export const messages = getMessages(enMessages);
